import { useSelector } from 'react-redux';
import MatchPage from './Match/MatchPage';
import ProfilePage from './Profile/ProfilePage';
import CalendarPage from './Calendar/CalendarPage';
import StorePage from './Store/StorePage';
import ChatsPage from './Chats/ChatsPage';

const PAGES = {
  match: MatchPage,
  profile: ProfilePage,
  calendar: CalendarPage,
  store: StorePage,
  chats: ChatsPage,
};

function PageDisplay() {
  const page = useSelector((s) => s.ui.currentPage);
  const Page = PAGES[page];

  return (
    <main className="min-h-0 flex-1 w-full overflow-hidden [transform:translateZ(0)]">
      <Page />
    </main>
  );
}

export default PageDisplay;
